// extracted by mini-css-extract-plugin
export default {"container":"home_container__Vmlb9","screen__content":"home_screen__content__v8kMD"};